import "./App.css";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Work from "./pages/Work";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
function App() {
  return (
    <>
    
    <BrowserRouter>
    <CssBaseline />
    <Container fixed > 
        <Nav />
      <Routes>
        <Route path="/" exact element={<Home />} />
        <Route path="/work" element ={<Work />} />
      </Routes>
      <Footer />
      </Container>
      </BrowserRouter>
    </>
  );
}

export default App;
